<template lang="pug">
v-container(fluid)
  //- Modo simplificado: dos bloques separados — líneas de negocio y productos/servicios
  .d-flex.flex-column(v-if="isSimpleMode" style="gap: 16px;")
    ListLineOfBusiness
    v-card
      v-card-title Productos y servicios
      v-card-subtitle Cada producto o servicio pertenece a una línea de negocio; puedes tener varios por línea.
      v-card-text
        SimpleProductsList
  //- Modo detallado: flujo completo (líneas, productos base, SKU)
  .d-flex.flex-column(v-else style="gap: 16px;")
    ListLineOfBusiness

    v-card(v-if="hasLineOfBusiness || hasBaseProducts || hasProducts")
      v-toolbar(flat)
        v-tabs(v-model="currentTab" :value="currentTab" grow)
          v-tab(v-for="tab in tabs" :key="tab") {{ tab }}
      v-tabs-items(v-model="currentTab")
        v-tab-item(key="Productos Base")
          ListBaseProducts
        v-tab-item(key="Productos para venta (sku)")
          ListProducts
</template>

<script>
import ListProducts from '@/components/products/ListProducts.vue'
import ListLineOfBusiness from '@/components/products/ListLineOfBusiness.vue'
import ListBaseProducts from '@/components/products/ListBaseProducts.vue'
import SimpleProductsList from '@/components/products/SimpleProductsList.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ListProducts,
    ListLineOfBusiness,
    ListBaseProducts,
    SimpleProductsList
  },
  methods: {
    ...mapActions('product', ['checkHasBaseProducts', 'checkHasLineOfBusiness', 'checkHasProducts']),
    parseTab() {

      if (this.$route.query.tab) {
        return parseInt(this.$route.query.tab)
      }
      return 0
    }
  },
  data() {
    return {
      currentTab: this.parseTab(),
      tabs: [
        'Productos Base',
        'Productos para venta (sku)',
      ],
    }
  },
  watch: {
    $route(to, from) {
      this.currentTab = this.parseTab()
    }
  },
  computed: {
    ...mapGetters('app_config', ['currentBusiness']),
    isSimpleMode() {
      return this.currentBusiness && this.currentBusiness.catalog_mode === 'simplificado'
    },
    hasBaseProducts() {
      return this.$store.state.product.hasBaseProducts
    },
    hasLineOfBusiness() {
      return this.$store.state.product.hasLineOfBusiness
    },
    hasProducts() {
      return this.$store.state.product.hasProducts
    },
  },
  created() {
    this.checkHasBaseProducts()
    this.checkHasLineOfBusiness()
    this.checkHasProducts()
  }
}
</script>